import Cookies from 'universal-cookie';
import { CookieUtils } from 'Shared/cookies/cookie-utils';
import { parseDomain } from './parse-domain';

declare const App: { siteid: string; which: string };

const cookies = new Cookies();

export const SettingsCookie = {
   get(name: string): string | undefined {
      return cookies.get(name + `_${App.siteid}`);
   },

   set(key: string, value: string, maxAge?: number): void {
      // ifixit-specific logic taken from CookieUtils::getCookieDomain.
      let baseDomain = window.location.host;
      if (App.which == 'ifixit') {
         baseDomain = parseDomain()['domain'];
      }
      const options = {
         domain: '.' + baseDomain,
         maxAgeInSeconds: maxAge ?? 2_592_000, // 30 days
      };
      CookieUtils.set(key + `_${App.siteid}`, value, options);
   },
};
